module.exports = __webpack_public_path__ + "img/floctori-banner.88a928b.png";